<template>
    <li class="uk-position-relative" :class="{ 'unavailable-ticket': !ticket.available || (ticket.required_ticket_types && !requirementMet()), ['tag-'+ticket.category.id]: true, 'singleview': !offerId || ticket.id == offerId, 'uk-active': selection, 'multiple': selection > 1, 'tag-coupon': ticket.coupon_required || ticket.coupon_highlight, 'disable-by-coupon': hasOtherSelectedCouponTickets, 'tag-added_by_coupon': ticket.coupon_required}">
        <div :class="{'ticket': true, 'with-image': ticket.image }">
            <div class="ticket-details uk-flex uk-flex-column uk-flex-between">
                <div>
                    <h4 class="uk-card-title uk-margin-remove" v-html="'<span>' + ticket.name.split(' ').join('</span> <span>') + '</span>'"></h4>
                    <div class="category">{{ticket.category.name}} <i uk-icon="info" v-if="ticket.category.description" :uk-tooltip="ticket.category.description"></i></div>
                    <p :class="{'uk-margin-remove-bottom': shortened && !opened}" v-html="getDescription()"></p>
                    <a class="showmore uk-display-inline-block" @click="opened = true" v-if="shortened && !opened">
                        {{ $t("Mehr erfahren") }}
                    </a>
                    <div v-if="ticket.category.detail">
                        <i uk-icon="info" :uk-tooltip="ticket.category.detail"></i>
                    </div>
                    <div v-if="ticket.options.length > 0">
                        <select class="uk-select options" v-model="option">
                            <option disabled value="">{{ $t("Bitte auswählen") }}</option>
                            <option v-for="option in ticket.options"
                                    :value="option.id">
                                {{ option.name }}
                            </option>
                        </select>
                    </div>

                </div>
                <div class="uk-text-large uk-text-bold uk-margin-top">
                    {{ getPrice(ticket,selection) }}
                    <div class="included-products" v-if="ticket.included_products.length" v-html="getIncludedProducts(ticket)"></div>
                </div>
            </div>

            <div class="ticket-image" v-if="ticket.image" :style="{backgroundImage: 'url('+ticket.image+')'}"></div>

            <div class="ticket-control">
                <div class="uk-flex uk-width-expand uk-flex-right uk-text-nowrap">
                    <div class="uk-form-controls">
                        <select class="uk-select" :disabled="ticket.options.length > 0 && !option" v-model="selection">
                            <option v-for="(i, amount) in Array(Math.max(0, getMaxOrderAmount(option)))"
                                    :value="amount">
                                {{ amount }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="unavailable-text" v-if="ticket.available_info == 'notyet'">{{ $t("Noch nicht verfügbar") }}</div>
            <div class="unavailable-text" v-else-if="ticket.required_ticket_types && !requirementMet()">{{ $t("Required") }}: {{ getRequiredText() }}</div>
            <div class="unavailable-text" v-else>{{ $t("Nicht mehr verfügbar") }}</div>
        </div>
    </li>
</template>

<script>
import helper from "../../helper/helper";
export default {
    mixins: [helper],
    props: ['ticket', 'id', 'offerId'],
    components: {},
    data: {
        optionMemory: '',
        shortened: false,
        opened: false,
        maxDescriptionLength: 200,
    },
    computed: {
        selection: {
            get() {
                if (this.ticket.required_ticket_types && !this.requirementMet() && this.store.state.selection[this.id]) {
                    delete this.store.state.selection[this.id]
                }
                return this.store.state.selection[this.id] ? this.store.state.selection[this.id].amount : 0;
            },
            set(amount) {
                let option = this.option;
                this.store.commit("addTicket", { ticketId: this.id, amount, option });
                this.$forceUpdate();
            }
        },
        hasOtherSelectedCouponTickets() {
            return Object.entries(this.store.state.selection).some(([id, selection]) => {
                return (this.ticket.coupon_required && selection.ticket.coupon_required && id != this.id)
            })
        },
        option: {
            get() {
                return this.store.state.selection[this.id] ? this.store.state.selection[this.id].option : this.optionMemory;
            },
            set(option) {
                if (this.store.state.selection[this.id]) {
                    this.store.commit("addTicket", { ticketId: this.id, amount: this.selection, option });
                    this.$forceUpdate();
                } else {
                    this.optionMemory = option
                }
                this.selection = Math.min(this.selection, this.getMaxOrderAmount(this.option) - 1)
            }
        },
        offers() {
            return this.store.state.offers;
        },
    },
    watch: {
        'store.state.selection': {
            deep: true,
            handler() {
                this.$forceUpdate();
            }
        }
    },
    mounted() {
        this.optionMemory = ''
    },
    methods: {
        getMaxOrderAmount(option_id) {
            let ticket_type_id = this.store.state.offers[this.id].offerable_id
            let option = null
            if (option_id) {
                for (let i in this.ticket.options) {
                    if (this.ticket.options[i].id == option_id) {
                        option = this.ticket.options[i]
                    }
                }
            }
            let max_amount = !option ? this.ticket.max_order_amount : option.max_order_amount

            if (typeof this.store.state.maxOrderAmounts.offerables[ticket_type_id] != 'undefined') {
                let alreadySelected = 0;
                let max_order_amount = !option ? this.store.state.maxOrderAmounts.offerables[ticket_type_id].max_order_amount : this.store.state.maxOrderAmounts.options[option_id].max_order_amount
                for (let idx in this.store.state.offers) {
                    if (idx != this.id && this.store.state.offers[idx].offerable_id == ticket_type_id && typeof this.store.state.selection[idx] != 'undefined') {
                        if (!option_id) {
                            alreadySelected += this.store.state.selection[idx].amount
                        } else {
                            if (this.store.state.selection[idx].option == option_id) {
                                alreadySelected += typeof this.store.state.selection[idx] != 'undefined' ? this.store.state.selection[idx].amount : 0
                            }
                        }
                    }
                }
                if (this.getCouponOverbookAllowance(option) > 0) {
                    // A covering coupon books into this option's overbook reserve
                    // (artist/crew extra seats). Allow exactly ONE seat per order, even
                    // when the option is publicly sold out — a single order must never
                    // drain the reserve. Regular remaining is irrelevant here: a coupon
                    // seat is booked against the reserve, not the public capacity. The
                    // global reserve size and any per-coupon usage limit are enforced by
                    // php-core (overbook_remaining shrinks per booked seat).
                    return Math.max(0, Math.min(1, max_amount) - alreadySelected) + 1
                }
                return Math.min(max_amount, max_order_amount - alreadySelected) + 1
            }
            return max_amount + 1
        },
        // Overbook reserve still available to this offer under an applied covering
        // coupon (artist/crew extra seats above the public bus capacity). php-core
        // shrinks overbook_remaining as coupon seats are booked, so once the reserve
        // is used up this returns 0 again. Used by getMaxOrderAmount ONLY as a gate
        // (> 0 → allow one overbook seat this order); the value itself is never added
        // to the regular remaining, so the reserve cannot be over-drawn from here.
        // Returns 0 when no applied coupon covers this offer, no reserve is left, or
        // php-core does not expose the field yet.
        getCouponOverbookAllowance(option) {
            if (!option) {
                return 0
            }
            const state = this.store.state
            const covered = state.couponValue && (state.couponOffers.length === 0 || state.couponOffers.includes(parseInt(this.id)))
            if (!covered) {
                return 0
            }
            return Math.max(0, parseInt(option.overbook_remaining) || 0)
        },
        getDescription() {
            if (this.offerId || this.opened || this.store.state.fullDescription || this.ticket.description.length <= this.maxDescriptionLength) {
                this.shortened = false
                return this.ticket.description.replace(/<br \/>/g, '<br /><span class="break"></span>')
            }
            this.shortened = true
            return this.ticket.description.substring(0, this.maxDescriptionLength)+'...'
        },
        getRequiredText() {
            let txt = '';
            for (let idx in this.store.state.offers) {
                if (this.store.state.offers[idx].available && this.ticket.required_ticket_types.includes(this.store.state.offers[idx].offerable_id.toString())) {
                    txt += (txt ? ', ' : '') + this.store.state.offers[idx].name
                }
            }
            return txt
        },
        requirementMet() {
            if (this.store.state.ownerData) {
                for (let idx in this.store.state.ownerData.ticket_types) {
                    if (this.ticket.required_ticket_types.includes(this.store.state.ownerData.ticket_types[idx].toString())) {
                        return true
                    }
                }
            }
            for (let idx in this.store.state.selection) {
                if (this.ticket.required_ticket_types.includes(this.store.state.offers[idx].offerable_id.toString())) {
                    return true
                }
            }
            return false
        }
    }
}
</script>
